import type { RouteRecordRaw } from 'vue-router';

export const REPORT_ROUTER: RouteRecordRaw[] = [
  {
    path: '/sales/report',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/sales/report/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/sales/report/views/List.vue'),
        name: 'Report List',
        meta: {
          title: '입판매 조회',
        },
      },
    ],
  },
];
